module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/assets/plugins/fonts/glyphicons-halflings-regular.woff2
// module id = ../../../../../src/assets/plugins/fonts/glyphicons-halflings-regular.woff2
// module chunks = styles